import { httpRequest } from "@/axios/axios-api";
import Vue from "vue";

export default {
  data() {
    return {
      majorName: "", // 专业的名字
      questionList: [],
      currentQuestionIdx: 0,
      currentQuestion: {},
      questionAnswerList: [], // 用户已答的所有问题的列表，长度与questionList一致，存储用户的答案，每道题存储选中的选项的sort值，多选题的情况，多个选项之间以英文逗号隔开，格式为：[{"ftqId"：123，"answer":"A,B", "eqId": 123}]
      optionSelectList: [], // 各个题目选择的状态记录，[{A:true, B:false}]
      isSubmitted: false, // 是否已提交答卷
      timer: null, // 计时器
      timerDuration: 0, // 考试倒计时进行中的当前时间，秒数
      timerStr: "00:00", // 考试倒计时时间，字符串，xx:xx
      examCostTimeString: "00分00秒", // 考试结束后总用时字符串，xx分xx秒
      examTotalDuration: 0, // 考试允许总时长，秒数
      ftId: 0, // 当前考试的id
      resultIcon: require("@/assets/exam/formal_exam_fail.png"), // 考试结果图标
      examResult: null, // 提交答案后返回的结果
      loadingQuestionList: true, // 是否正在加载问题列表
      submittingAnswers: false, // 正在提交答卷标志
      showCertOverlay: false, // 是否显示证书遮罩层
      uploadDialogVisible: false, // 是否显示上传弹窗
      paperName: "", // 选择上传的论文名字
      selectBtnIcon: require("@/assets/exam/icon_upload.png"),
      paperAuthStatus: 0, // 0未上传、1审核中、2审核通过、3审核驳回
      paperFile: null, // 选中的文件对象
      uploadingPaper: false // 是否正在上传论文
    };
  },
  created: function() {
    // 加载考题
    this.loadQuestionList();
  },
  beforeRouteLeave: function(to, from, next) {
    next(false); // 先阻止
    const _this = this;
    // 没有提交问卷的情况
    if (!this.isSubmitted) {
      this.$confirm("您还没有提交答卷，确定需要提出吗?", "提示", {
        confirmButtonText: "留在此页",
        cancelButtonText: "确定离开",
        closeOnPressEscape: false,
        closeOnHashChange: false,
        closeOnClickModal: false,
        showClose: false,
        type: "warning"
      })
        .then(() => {
          // 选择确定
        })
        .catch(() => {
          if (_this.timer !== null) {
            clearInterval(_this.timer);
            _this.timer = null;
          }
          if (to.name === "ExamRecord") {
            from.meta.keepAlive = false;
            _this.$destroy(); //销毁
          }
          next();
        });
    } else {
      if (_this.timer !== null) {
        clearInterval(_this.timer);
        _this.timer = null;
      }
      if (to.name === "ExamRecord") {
        from.meta.keepAlive = false;
        _this.$destroy(); //销毁
      }
      next();
    }
  },
  methods: {
    downloadCert() {
      // var a = document.createElement("a");
      // // const user = JSON.parse(localStorage.getItem("pc_user"));
      // a.download = "1213";
      //   // user.realName + "_" + this.examResult.majorName + "_资格证书";
      // // 设置图片地址
      // a.href = this.examResult.certificateUrl;
      // a.click();

      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      const _this = this;
      image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/jpg");

        // 生成一个a元素
        var a = document.createElement("a");
        // 创建一个单击事件
        var event = new MouseEvent("click");

        // 将a的download属性设置为我们想要下载的图片名称
        const user = JSON.parse(localStorage.getItem("pc_user"));
        a.download =
          user.realName + "_" + _this.examResult.major + "_专科护士合格证书";
        // 将生成的URL设置为a.href属性
        a.href = url;

        // 触发a的单击事件
        a.dispatchEvent(event);
      };
      image.src = this.examResult.certificateUrl;
    },
    // 加载当前问题的统一方法
    renderQuestion() {
      this.currentQuestion = this.questionList[this.currentQuestionIdx];
    },
    showExamResult(_this, data) {
      // 显示考试结果
      _this.ftId = data.ftId;
      _this.examResult = data;
      _this.resultIcon = data.pass
        ? require("@/assets/exam/formal_exam_success.png")
        : require("@/assets/exam/formal_exam_fail.png");
      // 计算考试用时
      const cost = _this.examResult.duration;
      _this.examCostTimeString =
        (cost / 60 < 10
          ? "0" + parseInt(Math.max(0, parseInt(cost / 60)))
          : parseInt(Math.max(0, parseInt(cost / 60)))) +
        "分" +
        (cost % 60 < 10 ? "0" + parseInt(cost % 60) : parseInt(cost % 60)) +
        "秒";
      _this.isSubmitted = true;
    },
    // 点击单个选项时触发的事件
    answer_question(sort) {
      let curUserAnswer = this.questionAnswerList[this.currentQuestionIdx][
        "answer"
      ]; // 用户已经选中的答案

      // 如果已经选了，则取消选择，如果没有选，则选中
      if (this.optionSelectList[this.currentQuestionIdx][sort]) {
        // 从用户答案中取消这个答案
        // eslint-disable-next-line prefer-const
        let curUserAnswerList = curUserAnswer.split(",");
        for (let uaIdx = 0; uaIdx < curUserAnswerList.length; uaIdx++) {
          if (curUserAnswerList[uaIdx] === sort) {
            curUserAnswerList.splice(uaIdx, 1);
            break;
          }
        }
        this.questionAnswerList[this.currentQuestionIdx][
          "answer"
        ] = curUserAnswerList.join(",");
      } else {
        // 如果没选中，就选择上
        // 此时需要区分单选题还是多选题
        // 单选题的情况，要先把所有选项清空，再将当前选中的设置进去
        if (this.currentQuestion.type === 0) {
          // 单选题，清空用户已经选中的
          this.questionAnswerList[this.currentQuestionIdx]["answer"] = "";
          for (let curSort in this.optionSelectList[this.currentQuestionIdx]) {
            Vue.set(
              this.optionSelectList[this.currentQuestionIdx],
              curSort,
              false
            );
          }
          curUserAnswer = sort;
        } else {
          curUserAnswer.length > 0
            ? (curUserAnswer += "," + sort)
            : (curUserAnswer += sort);
        }

        this.questionAnswerList[this.currentQuestionIdx][
          "answer"
        ] = curUserAnswer;
      }
      // 最后设置选中状态
      this.optionSelectList[this.currentQuestionIdx][sort] = !this
        .optionSelectList[this.currentQuestionIdx][sort];
    },
    // 上一题
    previous_question() {
      if (this.currentQuestionIdx > 0) {
        this.currentQuestionIdx--;
        this.renderQuestion();
      }
    },
    // 下一题
    next_question() {
      if (this.currentQuestionIdx < this.questionList.length - 1) {
        this.currentQuestionIdx++;
        this.renderQuestion();
      } else {
        this.submitExam();
      }
    },
    // 提交问卷
    submitExam() {
      // 弹窗提醒用户是否提交问卷
      this.$confirm("确认要提交问卷吗？")
        .then(() => {
          this.submitAnswers();
        })
        .catch(() => {});
    },
    async submitAnswers() {
      // 上传答案
      // 提交问卷
      const loadingInstance = this.$loading({ text: "正在提交" });
      if (this.timer !== null) {
        clearInterval(this.timer);
      }
      const _this = this;
      const data = {
        userAnswerList: _this.questionAnswerList,
        ftId: _this.ftId
      };
      const res = await httpRequest("/app/formal-test/total", "put", data);
      loadingInstance.close();
      if (res !== null && res !== undefined && res.code === 200) {
        this.$message.success("问卷已提交");
        // 显示答卷结果
        this.showExamResult(_this, res.data);
      } else {
        // 出错的情况，弹窗重试
        this.$alert(
          "提交出错，" +
            (res.message !== null && res.message !== undefined
              ? res.message
              : "点击重试"),
          "提示",
          {
            confirmButtonText: "确定",
            showClose: false,
            callback: () => {
              _this.submitAnswers();
            }
          }
        );
      }
    },
    async loadQuestionList() {
      // 根据传过来的参数来判断是何种形式，目前支持两种方式：做题&显示做题结果、直接显示某次考试的结果
      if (
        this.$route.query.ftId !== null &&
        this.$route.query.ftId !== undefined &&
        this.$route.query.ftId > 0
      ) {
        // 显示单次考试结果页面
        const params = {
          ftId: this.$route.query.ftId
        };
        const res = await httpRequest("/app/formal-test/info", "get", params);
        if (res !== null && res !== undefined && res.code === 200) {
          this.showExamResult(this, res.data);
        }
        this.loadingQuestionList = false;
        return;
      }
      // 走正常的获取考试题目的界面
      const res = await httpRequest("/app/formal-test/questions", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        if (
          res.data === null ||
          res.data === undefined ||
          res.data.length === 0 ||
          !(
            (res.data.examQuestionList !== null &&
              res.data.examQuestionList !== undefined &&
              res.data.examQuestionList.length !== 0) ||
            (res.data.examResult !== null && res.data.examResult !== undefined)
          )
        ) {
          this.loadingQuestionList = false;
          this.$message.error("数据异常，请重新进入考试");
          return;
        }
        if (res.data.examResult !== null && res.data.examResult !== undefined) {
          // 如果是考试完成的情况，则直接显示考试结果
          this.showExamResult(this, res.data.examResult);
          this.loadingQuestionList = false;
          return;
        }

        this.isSubmitted = false;
        this.questionList = res.data.examQuestionList;
        this.majorName = res.data.majorName;
        this.timerDuration = res.data.formalTestDuration;
        this.examTotalDuration = res.data.formalTestDuration;
        this.ftId = res.data.ftId;

        // 初始化用户答案列表参数questionAnswerList，与问题个数相同，每一个都设置格式为：{"peqid"："123"，"answer":"A,B"}
        this.questionAnswerList = new Array(this.questionList.length);
        this.optionSelectList = new Array(this.questionList.length);
        for (
          let qalIdx = 0;
          qalIdx < this.questionAnswerList.length;
          qalIdx++
        ) {
          this.questionAnswerList[qalIdx] = {
            ftqId: this.questionList[qalIdx].ftqId,
            answer: "",
            eqId: this.questionList[qalIdx].eqId
          }; // 初始化为未作答状态
          const options = this.questionList[qalIdx].optionList;
          let optionObj = {}; // {A:true, B:false}
          options.forEach(option => {
            Vue.set(optionObj, option.sort, false); // 每道题的每个选项的选中状态都先设置为false
          });
          Vue.set(this.optionSelectList, qalIdx, optionObj);
        }

        this.renderQuestion();
        // 开启定时器
        if (this.timer !== null) {
          clearInterval(this.timer);
        }
        const _this = this;
        _this.timerStr =
          (_this.timerDuration / 60 < 10
            ? "0" + parseInt(Math.max(0, parseInt(_this.timerDuration / 60)))
            : parseInt(Math.max(0, parseInt(_this.timerDuration) / 60))) +
          ":" +
          (_this.timerDuration % 60 < 10
            ? "0" + parseInt(_this.timerDuration % 60)
            : parseInt(_this.timerDuration % 60));
        this.timer = setInterval(function() {
          _this.timerDuration--;
          _this.timerStr =
            (_this.timerDuration / 60 < 10
              ? "0" + parseInt(Math.max(0, parseInt(_this.timerDuration / 60)))
              : parseInt(Math.max(0, parseInt(_this.timerDuration) / 60))) +
            ":" +
            (_this.timerDuration % 60 < 10
              ? "0" + parseInt(_this.timerDuration % 60)
              : parseInt(_this.timerDuration % 60));
          if (_this.timerDuration <= 0) {
            // 提交问卷
            clearInterval(_this.timer);
            // 弹窗提醒
            _this.$alert("倒计时结束，自动交卷", "提示", {
              confirmButtonText: "确定",
              showClose: false,
              callback: () => {
                // 提交问卷
                _this.submitAnswers();
              }
            });
          }
        }, 1000);
        this.loadingQuestionList = false;
      }
    },
    // 跳到指定问题
    jump2Question(index) {
      this.currentQuestionIdx = index;
      this.renderQuestion();
    },
    showFile(file) {
      this.paperFile = file;
      this.paperName = file.name;
    },
    delFile() {
      if (this.uploadingPaper) {
        return;
      }
      this.paperName = "";
      this.paperFile = null;
    },
    async uploadFile(params) {
      if (this.paperFile === null) {
        this.$message.error("请先选择文件，再上传");
        return;
      }
      if (this.uploadingPaper) {
        return;
      }
      this.uploadingPaper = true;
      const formData = new FormData();
      formData.append(params.filename, params.file);

      let res = await httpRequest(params.action, "post", formData);
      if (res !== null && res !== undefined && res.code === 200) {
        // 拿到文件url
        const data = {
          paperUrl: res.data[0],
          paperName: this.paperName,
          ftId: this.examResult.ftId
        };
        res = await httpRequest("/app/exam/apply/upload-paper", "put", data);
        if (res !== null && res !== undefined && res.code === 200) {
          this.$message.success("上传成功，等待审核");
          this.paperAuthStatus = res.data.paperAuthStatus;
          this.paperName = res.data.fileName;
          this.examResult.paperAuthStatus = res.data.paperAuthStatus;
          this.examResult.fileName = res.data.fileName;
        }
      }
      this.$nextTick(() => {
        this.uploadingPaper = false;
      });
    },
    handlePaperUploadError() {
      // this.$message.error("上传失败，请重试");
    },
    // 重新考试
    re_exam() {
      if (
        this.examResult.leftTimes !== null &&
        this.examResult.leftTimes !== undefined &&
        this.examResult.leftTimes !== 0
      ) {
        this.$confirm("您还剩一次考试机会，请谨慎考虑", "提示", {
          confirmButtonText: "我想好了",
          cancelButtonText: "我再想想",
          type: "warning"
        })
          .then(() => {
            // 重新请求问题
            this.loadQuestionList();
          })
          .catch(() => {});
      } else {
        this.$alert("您的机会已用完", "提示", {
          type: "warning"
        });
      }
    }
  }
};
